
import { ProjectHeader } from "@/components/projects/ProjectHeader";
import { useTranslation } from 'react-i18next';

export default function Help() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full site-gradient">
      <div className="container mx-auto py-8 px-4">
        <div className="max-w-4xl mx-auto space-y-8">
          <ProjectHeader />
          
          <div className="glass-card p-8 rounded-xl space-y-8">
            <h1 className="text-4xl font-bold">{t('help_center')}</h1>
            
            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">{t('getting_started')}</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('creating_first_project')}</h3>
                  <p className="text-muted-foreground">{t('creating_first_project_desc')}</p>
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('managing_gear_lists')}</h3>
                  <p className="text-muted-foreground">{t('managing_gear_lists_desc')}</p>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">{t('crew_management')}</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('crew_contacts')}</h3>
                  <p className="text-muted-foreground">{t('crew_contacts_desc')}</p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('adding_crew_to_projects')}</h3>
                  <p className="text-muted-foreground">{t('adding_crew_to_projects_desc')}</p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('project_collaboration')}</h3>
                  <p className="text-muted-foreground">{t('project_collaboration_desc')}</p>
                  <ul className="list-disc list-inside space-y-2 text-muted-foreground pl-4">
                    <li>{t('collab_share_with_user')}</li>
                    <li>{t('collab_choose_permission')}</li>
                    <li>{t('collab_access_on_accept')}</li>
                    <li>{t('collab_track_and_manage')}</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">{t('features')}</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('budget_tracking')}</h3>
                  <p className="text-muted-foreground">{t('budget_tracking_desc')}</p>
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('sharing_projects')}</h3>
                  <p className="text-muted-foreground">{t('sharing_projects_desc')}</p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">{t('inventory_management')}</h3>
                  <p className="text-muted-foreground">{t('inventory_management_desc')}</p>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">{t('need_more_help')}</h2>
              <p className="text-muted-foreground">
                {t('help_contact_support', { email: 'support@preptcine.com' })}
                <a 
                  href="mailto:info@preptcine.com" 
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  info@preptcine.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
